import React, { FC } from "react";
import { useQuery } from "@apollo/client";
import { GET_ME } from "../graphql/queries";
import { MeData, OrganiazationType } from "../models/types";

interface Props {
    organizationType: OrganiazationType;
    children: any;
}

const OrganizationProtectedComponentImplementation: FC<Props> = ({
    organizationType,
    children
}) => {
    const { data: { me } = {} } = useQuery<MeData>(GET_ME, {
        fetchPolicy: "cache-first"
    });

    if (!me || !me.organization) {
        return null;
    }
    if (me.organization.organizationType !== organizationType) {
        return null;
    }

    return <>{children}</>;
};

export const OrganizationProtectedComponent = React.memo(
    OrganizationProtectedComponentImplementation
);
